import { CREATE_PROJECT_ACTION, STATUS } from "../constant";

const initState = {
  isLoading: null,
  sectorsList: null,
  subSectorsList: null,
  schemesList: null,
  banksList: null,
  locationsList: null,
  projectDetail: null,
  pageDetail: null,
  implementationList: null,
  issuesStates: null,
  groupCategoryStatus: null,
  getResponsibleAuthorityData: [],
  getResponsibleAuthorityStatus: null,
  newMilestone: [],
  newMilestoneStatus: null
};

export default function(state = initState, action) {
  switch (action.type) {
    /**
     *  CREATE PROJECT START
     */
    case CREATE_PROJECT_ACTION.CREATE_PROJECT_START:
      return { ...state, createProjectStatus: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_SUCCESS:
      return { ...state, createProjectStatus: STATUS.SUCCESS };

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_FAILURE:
      return { ...state, createProjectStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_ISSUES_STATES_START:
      return { ...state, isLoading: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.GET_ISSUES_STATES_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };
    /**
     *   CREATE PROJECT END
     */

    case CREATE_PROJECT_ACTION.GET_ISSUES_STATES_SUCCESS:
      return {
        ...state,
        issuesStates: action.payload,
        isLoading: STATUS.SUCCESS
      };

    /**
     *   PROJECT DETAIL
     */
    case CREATE_PROJECT_ACTION.GET_PROJECT_DETAIL_START:
      return { ...state, isLoading: STATUS.LOADING };
    case CREATE_PROJECT_ACTION.GET_PROJECT_DETAIL_SUCCESS: {
      return {
        ...state,
        projectDetail: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case CREATE_PROJECT_ACTION.GET_PROJECT_DETAIL_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };
    /**
     *  End of project detail
     */

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_START:
      return { ...state, isLoading: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_SUCCESS:
      return {
        ...state,
        isLoading: STATUS.SUCCESS,
        pageDetail: action.payload
      };

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_SUB_SECTOR_LIST_SUCCESS:
      return { ...state, subSectorsList: action.payload };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_START:
      return { ...state, groupCategoryStatus: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_FAILURE:
      return { ...state, groupCategoryStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_SUCCESS:
      return { ...state, groupCategoryStatus: STATUS.SUCCESS };

    case CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_START:
      return { ...state, districtListForLocationStatus: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_SUCCESS:
      return {
        ...state,
        districtListForLocation: action.payload,
        districtListForLocationStatus: STATUS.SUCCESS
      };

    case CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_FAILURE:
      return { ...state, districtListForLocationStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_START:
      return { ...state, groupByCategoryAndIdStatus: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_FAILURE:
      return { ...state, groupByCategoryAndIdStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_SUCCESS:
      return {
        ...state,
        groupByCategoryAndIdStatus: STATUS.SUCCESS,
        groupByCategoryAndIdList: action.data
      };

    case CREATE_PROJECT_ACTION.EDIT_MILESTONE_START:
      return { ...state, editProjectMilestoneStatus: STATUS.LOADING };

    case CREATE_PROJECT_ACTION.EDIT_MILESTONE_SUCCESS:
      return { ...state, editProjectMilestoneStatus: STATUS.SUCCESS };

    case CREATE_PROJECT_ACTION.EDIT_MILESTONE_FAILURE:
      return { ...state, editProjectMilestoneStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_START:
      return {
        ...state,
        getBucketsWithMilestonesBySectorStatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_FAILURE:
      return { ...state, getBucketsWithMilestonesBySectorStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_SUCCESS:
      const getAllMilestoneData = action.payload;
      !!getAllMilestoneData &&
        !!getAllMilestoneData.data &&
        getAllMilestoneData.data.map(milesTn => {
          milesTn.milestones.map(keys => {
            keys.phaseIndex = "no_index";
          });
        });
      return {
        ...state,
        getBucketsWithMilestonesBySectorStatus: STATUS.SUCCESS,
        getBucketsWithMilestonesBySectorData: getAllMilestoneData
      };

    case CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_START:
      return {
        ...state,
        getResponsibleAuthorityStatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_FAILURE:
      return { ...state, getResponsibleAuthorityStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_SUCCESS:
      return {
        ...state,
        getResponsibleAuthorityStatus: STATUS.SUCCESS,
        getResponsibleAuthorityData: action.payload
      };

    case CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_START:
      return {
        ...state,
        newMilestoneStatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_FAILURE:
      return { ...state, newMilestoneStatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_SUCCESS:
      return {
        ...state,
        newMilestoneStatus: STATUS.SUCCESS,
        newMilestone: action.payload
      };

    case CREATE_PROJECT_ACTION.SAVE_NEW_MILESTONE:
      let bucketIndex = null;
      let bucketsData =
        state &&
        state.getBucketsWithMilestonesBySectorData &&
        state.getBucketsWithMilestonesBySectorData.data;
      let newRow = {
        id: action.payload.id,
        name: action.payload.name,
        newRow: true,
        predefined: false,
        phaseIndex: action.payload.phaseIndex
      };
      if (!!action.payload) {
        bucketIndex = bucketsData.findIndex(
          bucket => bucket.bucket.id === action.payload.bucketId
        );
        if (
          !bucketsData[bucketIndex].newMilestoneData[action.payload.phaseIndex]
        ) {
          bucketsData[bucketIndex].newMilestoneData[
            action.payload.phaseIndex
          ] = bucketsData[bucketIndex].milestones.filter(
            item => item.predefined === true
          );
        }
        bucketsData[bucketIndex].newMilestoneData[
          action.payload.phaseIndex
        ].push(newRow);
      }
      return { ...state };

    case CREATE_PROJECT_ACTION.DELETE_NEW_MILESTONE:
      let bucketIdx = null;
      let bucketData =
        state &&
        state.getBucketsWithMilestonesBySectorData &&
        state.getBucketsWithMilestonesBySectorData.data;
      if (!!action.payload) {
        bucketIdx = bucketData.findIndex(
          bucket => bucket.bucket.id === action.payload.bucketID
        );
        let bucketMilestoneData = bucketData && bucketData[bucketIdx];
        bucketMilestoneData &&
          bucketMilestoneData.newMilestoneData[
            action.payload.phaseIndex
          ].forEach(item => {
            let index = bucketMilestoneData.milestones.findIndex(
              milestone =>
                milestone.id === item.id && milestone.predefined === false
            );
            if (index !== -1) {
              bucketMilestoneData.milestones.splice(index, 1);
            }
          });
        if (
          action.payload.hasOwnProperty("type") &&
          action.payload.type === "phase"
        ) {
          bucketData.forEach(item => {
            item.newMilestoneData.splice(action.payload.phaseIndex, 1);
          });
        } else {
          let milestoneIndex = bucketMilestoneData.newMilestoneData[
            action.payload.phaseIndex
          ].findIndex(item => item.id === action.payload.milestoneID);
          if (milestoneIndex !== -1) {
            bucketMilestoneData.newMilestoneData[
              action.payload.phaseIndex
            ].splice(milestoneIndex, 1);
          }
        }
      }
      return { ...state };

    case CREATE_PROJECT_ACTION.DRAFT_NEW_MILESTONE:
      let getBucketIndex = null;
      let allBucketsData =
        state &&
        state.getBucketsWithMilestonesBySectorData &&
        state.getBucketsWithMilestonesBySectorData.data;
      if (!!action.payload) {
        action.payload.map(dp => {
          getBucketIndex =
            !!allBucketsData &&
            allBucketsData.findIndex(
              bucket => bucket.bucket.id === dp.bucketId
            );
          if (dp.milestoneTableDataCOS && dp.milestoneTableDataCOS.length > 0) {
            if (allBucketsData[getBucketIndex])
              allBucketsData[getBucketIndex].milestones = [];
            !!dp &&
              dp.milestoneTableDataCOS.length > 0 &&
              dp.milestoneTableDataCOS.map(table => {
                if (!allBucketsData[getBucketIndex]["newMilestoneData"]) {
                  allBucketsData[getBucketIndex].newMilestoneData = [];
                }
                allBucketsData[getBucketIndex].newMilestoneData.push(
                  table.milestoneDataCOS.map(item => item.milestone)
                );
                allBucketsData[getBucketIndex].newMilestoneData.map(
                  (phaseActivities, index) =>
                    phaseActivities.map(item => (item.phaseIndex = index))
                );
                table.milestoneDataCOS.map(ms => {
                  let __predefinedOBJ = {};
                  const checkMSExists = allBucketsData[
                    getBucketIndex
                  ].milestones.find(check => check.id === ms.milestone.id);
                  if (!ms.milestone.predefined) {
                    __predefinedOBJ.milesToneID = ms.milestone.id;
                    __predefinedOBJ.tableINDEX = table.tableIndex;
                    __predefinedOBJ.bucketID = dp.bucketId;
                  }
                  if (!ms.milestone.predefined || !checkMSExists) {
                    let _objDraftedMilestone = {
                      id: ms.milestone.id,
                      name: ms.milestone.name,
                      predefined: ms.milestone.predefined,
                      phaseIndex:
                        __predefinedOBJ.tableINDEX >= 0
                          ? __predefinedOBJ.tableINDEX
                          : "no_index"
                    };
                    if (allBucketsData[getBucketIndex]) {
                      allBucketsData[getBucketIndex].milestones.push(
                        _objDraftedMilestone
                      );
                    }
                  }
                });
              });
          }
        });
      }
      let phasesCount = allBucketsData.map(item => {
        return !!item.newMilestoneData && !!item.newMilestoneData.length
          ? item.newMilestoneData.length
          : 0;
      });
      const maxPhaseCount = phasesCount.reduce((previousItem, nextItem) =>
        Math.max(previousItem, nextItem)
      );

      allBucketsData.map(item => {
        if (
          !item["newMilestoneData"] &&
          !item.milestones.some(item => item.predefined === false)
        ) {
          let milestoneData = item.milestones;
          item.newMilestoneData = [];
          for (let index = 0; index <= maxPhaseCount - 1; index++) {
            if (!item.newMilestoneData[index]) {
              item.newMilestoneData[index] = [];
            }
            item.newMilestoneData[index] = milestoneData;
          }
        }
      });
      return {
        ...state,
        getBucketsWithMilestonesBySectorData: {
          data: allBucketsData
        }
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_START:
      return {
        ...state,
        isIssueDeleteExiststatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_FAILURE:
      return { ...state, isIssueDeleteExiststatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_SUCCESS:
      return {
        ...state,
        isIssueDeleteExiststatus: STATUS.SUCCESS,
        isIssueForDeleteExists: action.payload
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_START:
      return {
        ...state,
        isIssueDisableExiststatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_FAILURE:
      return { ...state, isIssueDisableExiststatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_SUCCESS:
      return {
        ...state,
        isIssueDisableExiststatus: STATUS.SUCCESS,
        isIssueForDisableExists: action.payload
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_START:
      return {
        ...state,
        isBucketIssueExiststatus: STATUS.LOADING
      };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_FAILURE:
      return { ...state, isBucketIssueExiststatus: STATUS.ERROR };

    case CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_SUCCESS:
      return {
        ...state,
        isBucketIssueExiststatus: STATUS.SUCCESS,
        isBucketIssueForDisableExists: action.payload
      };

    case CREATE_PROJECT_ACTION.CREATE_PROJECT_START:
      return {
        ...state,
        createProjectStatus: STATUS.LOADING
      };
    case CREATE_PROJECT_ACTION.CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        createProjectData: action.payload,
        createProjectStatus: STATUS.SUCCESS
      };
    case CREATE_PROJECT_ACTION.CREATE_PROJECT_FAILURE:
      return {
        ...state,
        createProjectStatus: STATUS.ERROR
      };
    default:
      return state;
  }
}
